(() => {
  if (window.FizoProductCardInteractions) return;
  window.FizoProductCardInteractions = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-fizo-colour-swatch]');
    if (!swatch) return;

    const card = swatch.closest('[data-fizo-collection-product-card]');
    const image = card?.querySelector('.fizo-collection-card__image--primary');
    const hoverImage = card?.querySelector('.fizo-collection-card__image--hover');
    const nextImage = swatch.dataset.fizoColourImage;
    const nextHoverImage = swatch.dataset.fizoColourHoverImage;
    if (!card || !image || !nextImage) return;

    event.preventDefault();
    event.stopPropagation();
    image.classList.add('is-switching');
    image.src = nextImage;
    image.removeAttribute('srcset');
    image.addEventListener('load', () => image.classList.remove('is-switching'), {once: true});

    if (hoverImage) {
      const hoverRequest = nextHoverImage || '';
      hoverImage.hidden = true;
      hoverImage.dataset.fizoHoverRequest = hoverRequest;
      hoverImage.removeAttribute('srcset');
      if (hoverRequest) {
        const pendingHoverImage = new Image();
        pendingHoverImage.addEventListener('load', () => {
          if (hoverImage.dataset.fizoHoverRequest !== hoverRequest) return;
          hoverImage.src = hoverRequest;
          hoverImage.hidden = false;
        }, {once: true});
        pendingHoverImage.src = hoverRequest;
      } else {
        hoverImage.removeAttribute('src');
      }
    }

    card.querySelectorAll('[data-fizo-colour-swatch]').forEach((button) => {
      const active = button === swatch;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  });
})();
